/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import {
  Card,
  Tabs,
  Tab,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Tooltip,
  FormControl,
  Select,
  Drawer,
  InputLabel,
  Box,
  IconButton,
  Fade,
} from "@material-ui/core";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Edit,
  Delete,
  AddCircle,
  Save,
  Search,
  SaveAlt,
  Cancel,
  CheckCircle,
  HourglassEmpty,
  Close as CloseIcon,
  EmojiObjects,
  FileCopy,
  Info,
} from "@material-ui/icons";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ChecklistRtlIcon from "@material-ui/icons/AssignmentTurnedIn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faSort,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import GridItem from "components/Grid/GridItem";
import TextEditor from "components/TextEditor/TextEditor.js";
import GridContainer from "components/Grid/GridContainer";
import * as XLSX from "xlsx";
import { ThreeDots } from "react-loader-spinner";

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { client } from "../../services/axiosClient";
import { toast } from "react-toastify";
import {
  performApprovalAction,
  approveAllDeliverables,
} from "services/deliverablesApi";

import {
  createDeliverable,
  updateDeliverable,
  deleteDeliverable,
} from "services/deliverablesApi";
import AuthContext from "contexts/AuthProvider";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import PerfectScrollbar from "react-perfect-scrollbar";
import { generateDeliverableInsights } from "services/aiApi";
import { useTranslation } from "react-i18next";
import DeliverableInsightsLoading from "components/DeliverableInsightsLoading/DeliverableInsightsLoading";
import AIInsightsModal from "components/AI/AIInsightsModal";

//width of each cell (each day) on the timeline


const SaveButton = ({ onClick, loading }) => (
  <IconButton // mantém a área clicável
    size="small"
    onClick={loading ? undefined : onClick}
    disableRipple // remove o efeito ripple ao clicar
    disableFocusRipple // remove o ripple ao focar via tecla
    style={{
      color: "#000",
      position: "absolute",
      right: 10,
      top: 5,
      width: 32, // ≅ 20 px do ícone + padding
      height: 32,
      backgroundColor: "transparent", // sem fundo
      boxShadow: "none",
    }}
  >
    {loading ? (
      <ThreeDots height={18} width={18} color="#000" />
    ) : (
      <Save style={{ fontSize: 20 }} />
    )}
  </IconButton>
);

/*====================== CUSTOMGANTT COMPONENT =================== */
/*Render the gantt with:
   -Fixed table on the left (as a table with Thead, Tbody and TFOOT)
   -Right timeline on the right with dates and bars that display an internal bar representing the percentage.
   -If the inline editing mode is active, some fields become inputs.
   -The column headers are clickable for Sort.
*/
function CustomGantt({
  tasks,
  onTaskClick,
  onDeleteTask,
  calcTotalDays,
  inlineEditMode,
  updateDeliverableField,
  stages,
  classes,
  sortConfig,
  onSort,
  owners,
  t,
  translateStage,
  canApprove,
  onApprovalAction,
  isApproving,
  readOnly = false, // Novo parâmetro para modo somente leitura
  renderStatusDot, // Passando a função como prop
  renderDeliverableName, // Passando a função como prop
  deliverablesLayout, // Nova prop para configuração de layout
  userDetails, // Prop para regras de status dos entregáveis
  dirtyRows = new Set(), // Linhas modificadas para feedback visual
}) {
  const [viewMode, setViewMode] = useState("month");
  const [hoveredRowId, setHoveredRowId] = useState(null);
  
  const CELL_PX = { daily: 45, weekly: 55, month: 65, quarter: 70, year: 80 };
  const GANTT_ROW_HEIGHT = 35;  // Use consistent row height for both table and grid
  const rowHeight = GANTT_ROW_HEIGHT;

  //determines the timeline period based on the tasks dates
  const { timelineStart, timelineEnd } = useMemo(() => {
    if (!tasks || tasks.length === 0) {
      const now = new Date();
      const year = now.getUTCFullYear();
      return { 
        timelineStart: new Date(Date.UTC(year, 0, 1)), 
        timelineEnd: new Date(Date.UTC(year, 11, 1)) 
      };
    }
    
    const starts = tasks.map((t) => t.start);
    const ends = tasks.map((t) => t.end);
    const minStart = new Date(Math.min(...starts));
    const maxEnd = new Date(Math.max(...ends));
    
    // Add buffer based on view mode
    let timelineStart = new Date(minStart);
    if (viewMode === "daily") {
      timelineStart.setUTCDate(timelineStart.getUTCDate() - 7);
    } else if (viewMode === "weekly") {
      timelineStart.setUTCDate(timelineStart.getUTCDate() - 14);
    } else if (viewMode === "month") {
      timelineStart.setUTCMonth(timelineStart.getUTCMonth() - 1);
    } else if (viewMode === "quarter") {
      timelineStart.setUTCMonth(timelineStart.getUTCMonth() - 3);
    } else {
      timelineStart.setUTCFullYear(timelineStart.getUTCFullYear() - 1);
    }
    
    // Ensure we start from the beginning of the period
    if (viewMode === "daily" || viewMode === "weekly") {
      // For daily/weekly, start from the beginning of the week (Monday)
      const dayOfWeek = timelineStart.getUTCDay();
      const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Convert Sunday=0 to Monday=0
      timelineStart.setUTCDate(timelineStart.getUTCDate() - daysToSubtract);
    } else {
      timelineStart.setUTCDate(1);
      if (viewMode === "quarter") timelineStart.setUTCMonth(Math.floor(timelineStart.getUTCMonth() / 3) * 3);
      if (viewMode === "year") timelineStart.setUTCMonth(0);
    }
    
    let timelineEnd = new Date(maxEnd);
    if (viewMode === "daily") {
      timelineEnd.setUTCDate(timelineEnd.getUTCDate() + 7);
    } else if (viewMode === "weekly") {
      timelineEnd.setUTCDate(timelineEnd.getUTCDate() + 14);
    } else if (viewMode === "month") {
      timelineEnd.setUTCMonth(timelineEnd.getUTCMonth() + 1);
    } else if (viewMode === "quarter") {
      timelineEnd.setUTCMonth(timelineEnd.getUTCMonth() + 3);
    } else {
      timelineEnd.setUTCFullYear(timelineEnd.getUTCFullYear() + 1);
    }
    
    // Ensure we end at the beginning of the next period
    if (viewMode === "daily" || viewMode === "weekly") {
      // For daily/weekly, end at the beginning of the next week
      const dayOfWeek = timelineEnd.getUTCDay();
      const daysToAdd = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
      timelineEnd.setUTCDate(timelineEnd.getUTCDate() + daysToAdd);
    } else {
      timelineEnd.setUTCDate(1);
      if (viewMode === "quarter") timelineEnd.setUTCMonth(Math.floor(timelineEnd.getUTCMonth() / 3) * 3);
      if (viewMode === "year") timelineEnd.setUTCMonth(0);
    }
    
    return { timelineStart, timelineEnd };
  }, [tasks, viewMode]);

  // Helper functions for different view modes
  const diffPeriods = (d1, d2) => {
    if (!d1 || !d2) return 0;
    if (viewMode === "daily") {
      const timeDiff = d2.getTime() - d1.getTime();
      return Math.floor(timeDiff / (1000 * 3600 * 24));
    } else if (viewMode === "weekly") {
      const timeDiff = d2.getTime() - d1.getTime();
      return Math.floor(timeDiff / (1000 * 3600 * 24 * 7));
    } else if (viewMode === "month") {
      return (d2.getUTCFullYear() - d1.getUTCFullYear()) * 12 + d2.getUTCMonth() - d1.getUTCMonth();
    } else if (viewMode === "quarter") {
      return (d2.getUTCFullYear() - d1.getUTCFullYear()) * 4 + Math.floor(d2.getUTCMonth() / 3) - Math.floor(d1.getUTCMonth() / 3);
    } else {
      return d2.getUTCFullYear() - d1.getUTCFullYear();
    }
  };

  // Generate periods based on view mode
  const periods = useMemo(() => {
    const out = [];
    const cur = new Date(timelineStart.getTime());
    
    if (viewMode === "daily") {
      while (cur <= timelineEnd) {
        out.push({ 
          y: cur.getUTCFullYear(), 
          m: cur.getUTCMonth(), 
          d: cur.getUTCDate(),
          dayName: cur.toLocaleDateString('en-US', { weekday: 'short' }),
          monthName: cur.toLocaleDateString('en-US', { month: 'short' })
        });
        cur.setUTCDate(cur.getUTCDate() + 1);
      }
    } else if (viewMode === "weekly") {
      while (cur <= timelineEnd) {
        const weekStart = new Date(cur.getTime());
        const weekEnd = new Date(cur.getTime());
        weekEnd.setUTCDate(weekEnd.getUTCDate() + 6);
        
        // Determina o mês principal da semana (onde a maioria dos dias está)
        const weekMiddle = new Date(cur.getTime());
        weekMiddle.setUTCDate(weekMiddle.getUTCDate() + 3);
        const primaryMonth = weekMiddle.getUTCMonth();
        const primaryYear = weekMiddle.getUTCFullYear();
        
        out.push({ 
          y: primaryYear, 
          m: primaryMonth,
          weekStart: weekStart.getUTCDate(),
          weekEnd: weekEnd.getUTCDate(),
          weekMonth: primaryMonth,
          monthName: weekMiddle.toLocaleDateString('en-US', { month: 'short' })
        });
        cur.setUTCDate(cur.getUTCDate() + 7);
      }
    } else if (viewMode === "month") {
      while (cur <= timelineEnd) {
        out.push({ y: cur.getUTCFullYear(), m: cur.getUTCMonth() });
        cur.setUTCMonth(cur.getUTCMonth() + 1);
      }
    } else if (viewMode === "quarter") {
      while (cur <= timelineEnd) {
        out.push({ y: cur.getUTCFullYear(), q: Math.floor(cur.getUTCMonth() / 3) + 1 });
        cur.setUTCMonth(cur.getUTCMonth() + 3);
      }
    } else {
      while (cur <= timelineEnd) {
        out.push({ y: cur.getUTCFullYear() });
        cur.setUTCFullYear(cur.getUTCFullYear() + 1);
      }
    }
    return out;
  }, [timelineStart, timelineEnd, viewMode]);

  // Helper function to get grid position for a date
  const getGridPos = (date) => {
    if (!(date instanceof Date)) return null;
    return diffPeriods(timelineStart, date) + 1;
  };

  function translateCategory(category) {
    if (!category) return ""; // ✔️ proteção
    const lower = String(category).toLowerCase();

    if (lower === "task") return t("execution.category_task");
    if (lower === "risk") return t("execution.category_risk");
    return category; // fallback
  }

  function translateLaunchPhase(launchPhase) {
    if (!launchPhase) return ""; // ✔️ proteção
    const lower = String(launchPhase).toLowerCase();

    if (lower === "mvp") return t("execution.launch_phase_mvp");
    if (lower === "launch") return t("execution.launch_phase_launch");
    return launchPhase; // fallback
  }

  function translateBoolean(value) {
    if (value === true) return "Sim";
    if (value === false) return "Não";
    return "";
  }

  //Function to render the sound icon for each column
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return (
        <FontAwesomeIcon
          icon={faSort}
          className={classes.sortIcon}
        />
      );
    } else if (sortConfig.direction === "asc") {
      return (
        <FontAwesomeIcon
          icon={faSortUp}
          className={`${classes.sortIcon} ${classes.activeSortIcon}`}
        />
      );
    } else {
      return (
        <FontAwesomeIcon
          icon={faSortDown}
          className={`${classes.sortIcon} ${classes.activeSortIcon}`}
        />
      );
    }
  };



  return (
    <>
      {/*Single container that will have vertical (y) and horizontal (x) scroll for all Gantt */}
      <div className={classes.ganttMaster} style={{ marginTop: "15px", marginLeft: "-10px", marginRight: "-10px" }}>
        {/* Controls */}
        <div
          style={{
            display: "flex", flexWrap: "wrap", gap: 12,
            alignItems: "center", justifyContent: "space-between",
            margin: "15px 4px 4px 4px",
          }}
        >
          {/* View mode controls - apenas quando não for modo somente leitura */}
          {!readOnly && (
            <div className={classes.viewButtonsContainer} style={{ position: "static", marginLeft: "3px", marginBottom: "-6px", marginTop: "3px" }}>
              <Button
                size="xs"
                simple={viewMode !== "daily"}
                className={cx(classes.viewButton, classes.firstButtonDate, { [classes.buttonSelectedDate]: viewMode === "daily" })}
                onClick={() => setViewMode("daily")}
              >
                {t("execution.daily")}
              </Button>
              <Button
                size="xs"
                simple={viewMode !== "weekly"}
                className={cx(classes.viewButton, classes.middleButtonDate, { [classes.buttonSelectedDate]: viewMode === "weekly" })}
                onClick={() => setViewMode("weekly")}
              >
                {t("execution.weekly")}
              </Button>
              <Button
                size="xs"
                simple={viewMode !== "month"}
                className={cx(classes.viewButton, classes.middleButtonDate, { [classes.buttonSelectedDate]: viewMode === "month" })}
                onClick={() => setViewMode("month")}
              >
                {t("execution.monthly")}
              </Button>
              <Button
                size="xs"
                simple={viewMode !== "quarter"}
                className={cx(classes.viewButton, classes.middleButtonDate, { [classes.buttonSelectedDate]: viewMode === "quarter" })}
                onClick={() => setViewMode("quarter")}
              >
                {t("execution.quarterly")}
              </Button>
              <Button
                size="xs"
                simple={viewMode !== "year"}
                className={cx(classes.viewButton, classes.lastButtonDate, { [classes.buttonSelectedDate]: viewMode === "year" })}
                onClick={() => setViewMode("year")}
              >
                {t("execution.yearly")}
              </Button>
            </div>
          )}
        </div>

        {/*Container flex: table + timeline side by side,
        But now the table is not fixed (Sticky Left) -
        Thus, when rolling horizontally, everything moves together */}
        <div style={{ display: "flex" }}>
          {/*TABLE */}
          <div
            className={classes.ganttTable}
            style={{
              flex: "0 0 auto",
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead className={classes.ganttTableHeader} style={{ height: viewMode === "daily" || viewMode === "weekly" ? rowHeight + 8 : rowHeight }}>
                <tr>
                  {/* Renderização dinâmica dos headers baseada na configuração */}
                  {(deliverablesLayout?.table_columns || []).map((col, index) => (
                  <th
                      key={col.key}
                      onClick={() => col.sortable && onSort(col.key)}
                    className={classes.ganttTableColumns}
                      style={{ cursor: col.sortable ? "pointer" : "default" }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                        {t(col.header_key)}{" "}
                        {col.sortable && renderSortIcon(col.key)}
                        {/* Ícone Info apenas na primeira coluna */}
                        {index === 0 && userDetails?.deliverable_status_rules && (
                          <Tippy
                            content={
                              <div style={{ whiteSpace: "pre-line" }}>
                                {userDetails.deliverable_status_rules}
                              </div>
                            }
                            theme="light"
                            arrow={true}
                            placement="top"
                            zIndex={10002}
                            appendTo={() => document.body}
                            popperOptions={{
                              modifiers: [
                                {
                                  name: 'zIndex',
                                  enabled: true,
                                  phase: 'write',
                                  fn: ({ state }) => {
                                    state.styles.popper.zIndex = '10002';
                                  }
                                }
                              ]
                            }}
                          >
                            <Info
                              style={{
                                fontSize: "16px",
                                color: "#666",
                                cursor: "pointer",
                                marginLeft: "4px",
                              }}
                            />
                          </Tippy>
                        )}
                    </span>
                  </th>
                  ))}
                  {/* Coluna Actions - apenas quando não for modo somente leitura */}
                  {!readOnly && (
                    <th
                      style={{
                        padding: "4px",
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: "13px",
                        fontFamily: "Roboto",
                      }}
                    >
                      {t("execution.actions")}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {tasks.map((task) => {
                  const isDirty = dirtyRows.has(task.id);
                  return (
                  <tr
                    key={task.id}
                    style={{
                      height: rowHeight,
                      borderBottom: "1px solid #f0f0f0",
                      backgroundColor: isDirty 
                        ? "#fff8e1" // Amarelo claro para linhas modificadas
                        : hoveredRowId === task.id 
                          ? "#f5f5f5" 
                          : "transparent",
                      borderLeft: isDirty ? "3px solid #ffc107" : "none", // Indicador lateral
                      transition: "background-color 0.2s ease",
                    }}
                    onMouseEnter={() => setHoveredRowId(task.id)}
                    onMouseLeave={() => setHoveredRowId(null)}
                  >
                    {/* Renderização dinâmica das células baseada na configuração */}
                    {(deliverablesLayout?.table_columns || []).map((col, colIndex) => {
                      const renderCellContent = () => {
                        switch (col.type) {
                          case "text":
                            if (col.key === "deliverable_name") {
                              // Primeira coluna especial com aprovações e edição inline
                              return (
                                <div
                      onClick={() => !inlineEditMode && !readOnly && onTaskClick(task)}
                      style={{ cursor: (!inlineEditMode && !readOnly) ? "pointer" : "default" }}
                    >
                      {task.approval_status === "pending" && (
                        <Tooltip
                          title={t("approvals.pending_approval_tooltip")}
                          disablePortal={false}
                          style={{ zIndex: 10001 }}
                        >
                          <HourglassEmpty
                            style={{
                              color: "#F4C430",
                              fontSize: 14,
                              marginRight: 4,
                              verticalAlign: "middle",
                            }}
                          />
                        </Tooltip>
                      )}
                        {inlineEditMode ? (
                          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            {renderStatusDot(task.status, task.stage)}
                            <TextField
                              type="text"
                              size="small"
                              value={task.text}
                              onChange={(e) =>
                                updateDeliverableField(
                                  task.id,
                                  "deliverable_name",
                                  e.target.value
                                )
                              }
                              classes={{ root: classes.textFieldRoot }}
                              InputProps={{
                                classes: { input: classes.inputText },
                                style: { fontSize: "11px" },
                              }}
                              InputLabelProps={{
                                classes: { root: classes.labelText },
                                shrink: true,
                              }}
                              style={{ flex: 1 }}
                            />
                          </div>
                        ) : (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {renderStatusDot(task.status, task.stage)}
                            <span
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "125px",
                                width: "100%",
                                display: "block",
                                cursor: readOnly ? "default" : "pointer",
                                textDecoration: readOnly ? "none" : "underline",
                                textDecorationColor: "#aaa",
                                textUnderlineOffset: "2px",
                              }}
                            >
                              {renderDeliverableName(task.text)}
                            </span>
                          </div>
                        )}
                                </div>
                              );
                            }
                            // Campo owner com Autocomplete e busca
                            if (col.key === "owner") {
                              if (inlineEditMode) {
                                // Opções: apenas os owners reais (sem "Sem responsável" como opção fixa)
                                const ownerOptions = [...owners];
                                // Encontra o owner atual (ou null se não tiver)
                                const selectedOwner = task.responsible_id 
                                  ? ownerOptions.find(u => u.id === task.responsible_id) || null
                                  : null;
                                
                                return (
                                  <Autocomplete
                                    size="small"
                                    options={ownerOptions}
                                    getOptionLabel={(option) => option?.name || ""}
                                    getOptionSelected={(option, value) => option?.id === value?.id}
                                    value={selectedOwner}
                                    onChange={(event, newValue) => {
                                      const userId = newValue?.id || null;
                                      const userName = newValue?.name || "";

                                      updateDeliverableField(
                                        task.id,
                                        "responsible_id",
                                        userId
                                      );

                                      updateDeliverableField(
                                        task.id,
                                        "owner",
                                        userName
                                      );
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="standard"
                                        placeholder={selectedOwner ? "" : t("execution.search_owner")}
                                        classes={{ root: classes.textFieldRoot }}
                                        InputProps={{
                                          ...params.InputProps,
                                          classes: { input: classes.inputText },
                                          style: { fontSize: "11px" },
                                        }}
                                      />
                                    )}
                                    renderOption={(option) => (
                                      <span style={{ fontSize: "12px" }}>
                                        {option.name}
                                      </span>
                                    )}
                                    noOptionsText={t("execution.no_owner_found")}
                                    style={{ minWidth: "120px" }}
                                    clearOnEscape
                                  />
                                );
                              }
                              return task[col.key] || "-";
                            }
                            return task[col.key] || "";

                          case "date":
                            if (inlineEditMode) {
                              // Para edição, usar a string de data diretamente
                              let dateValue = "";
                              if (col.key === "planned_start_date" || col.key === "planned_end_date") {
                                dateValue = task[col.key] || "";
                              } else if (task[col.key] instanceof Date) {
                                dateValue = task[col.key].toISOString().split("T")[0];
                              } else {
                                dateValue = task[col.key] || "";
                              }
                              
                              return (
                        <TextField
                          type="date"
                          size="small"
                                  value={dateValue}
                          onChange={(e) =>
                            updateDeliverableField(
                              task.id,
                                      col.key,
                              e.target.value
                            )
                          }
                          classes={{ root: classes.textFieldRoot }}
                          InputProps={{
                            classes: { input: classes.inputText },
                            style: { fontSize: "11px" },
                          }}
                          InputLabelProps={{
                            classes: { root: classes.labelText },
                            shrink: true,
                          }}
                        />
                              );
                            }
                            
                            // Para exibição, verificar se é uma data válida
                            let dateToShow;
                            if (col.key === "planned_start_date") {
                              dateToShow = task.start;
                            } else if (col.key === "planned_end_date") {
                              dateToShow = task.end;
                            } else {
                              dateToShow = task[col.key] instanceof Date ? task[col.key] : new Date(task[col.key]);
                            }
                            
                            // Verificar se a data é válida
                            if (!dateToShow || isNaN(dateToShow.getTime())) {
                              return "-";
                            }
                            
                            return `${dateToShow.getDate().toString().padStart(2, "0")}-${t(`months.${dateToShow.getMonth() + 1}`)}-${dateToShow.getFullYear()}`;

                          case "category":
                            if (inlineEditMode) {
                              return (
                        <FormControl
                          fullWidth
                          className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                        >
                          <Select
                            label={t("execution.category")}
                            value={task.category ?? ""}
                            onChange={(e) =>
                              updateDeliverableField(
                                task.id,
                                "category",
                                e.target.value
                              )
                            }
                            displayEmpty
                            classes={{
                              select: `${classes.select} ${classes.selectFormControlOverride}`,
                            }}
                            size="small"
                          >
                                    <MenuItem value="task" classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                              {t("execution.category_task")}
                            </MenuItem>
                                    <MenuItem value="risk" classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                              {t("execution.category_risk")}
                            </MenuItem>
                          </Select>
                        </FormControl>
                              );
                            }
                            return translateCategory(task.category);

                          case "stage":
                            if (inlineEditMode) {
                              return (
                        <FormControl
                          fullWidth
                          className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                        >
                          <Select
                                    value={task.stage}
                                    onChange={(e) =>
                              updateDeliverableField(
                                task.id,
                                        "stage",
                                        e.target.value
                                      )
                                    }
                                    displayEmpty
                            classes={{
                              select: `${classes.select} ${classes.selectFormControlOverride}`,
                            }}
                                    size="small"
                          >
                                    {stages.map((st) => (
                              <MenuItem
                                        key={st}
                                        value={st}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                              >
                                        {translateStage(st)}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                              );
                            }
                            return translateStage(task.stage);

                          case "launch_phase":
                            if (inlineEditMode) {
                              return (
                        <FormControl
                          fullWidth
                          className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                        >
                                                            <Select
                                    value={task.launch_phase || ""}
                                    onChange={(e) => {
                                      updateDeliverableField(
                                        task.id,
                                        "launch_phase",
                                        e.target.value
                                      );
                                    }}
                            displayEmpty
                            classes={{
                              select: `${classes.select} ${classes.selectFormControlOverride}`,
                            }}
                            size="small"
                          >
                                    <MenuItem value="" classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                                      -
                                    </MenuItem>
                                    <MenuItem value="mvp" classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                                      {t("execution.launch_phase_mvp")}
                                    </MenuItem>
                                    <MenuItem value="launch" classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                                      {t("execution.launch_phase_launch")}
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              );
                            }
                            return translateLaunchPhase(task.launch_phase);

                          case "boolean":
                            if (inlineEditMode) {
                              const currentValue = task[col.key] || false;
                              return (
                                <FormControl
                                  fullWidth
                                  className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                                >
                                  <Select
                                    value={currentValue}
                                    onChange={(e) => {
                                      updateDeliverableField(
                                        task.id,
                                        col.key,
                                        e.target.value
                                      );
                                    }}
                                classes={{
                                      select: `${classes.select} ${classes.selectFormControlOverride}`,
                                }}
                                    size="small"
                              >
                                    <MenuItem value={false} classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                                      Não
                              </MenuItem>
                                    <MenuItem value={true} classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                                      Sim
                                    </MenuItem>
                          </Select>
                        </FormControl>
                              );
                            }
                            return translateBoolean(task[col.key]);

                          case "deliverable_status":
                            if (inlineEditMode) {
                              return (
                                <FormControl
                                  fullWidth
                                  className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                                >
                                  <Select
                                    value={task.status || "on_track"}
                                    onChange={(e) => {
                                      updateDeliverableField(
                                        task.id,
                                        "status",
                                        e.target.value
                                      );
                                    }}
                                    displayEmpty
                                    classes={{
                                      select: `${classes.select} ${classes.selectFormControlOverride}`,
                                    }}
                                    size="small"
                                  >
                                    <MenuItem value="on_track" classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                                      <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "green" }} />
                                        {t("execution.on_track")}
                                      </span>
                                    </MenuItem>
                                    <MenuItem value="at_risk" classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                                      <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#F4C430" }} />
                                        {t("execution.at_risk")}
                                      </span>
                                    </MenuItem>
                                    <MenuItem value="delayed" classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}>
                                      <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#E04F5F" }} />
                                        {t("execution.delayed")}
                                      </span>
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              );
                            }
                            // Modo de visualização: mostra o círculo colorido com tooltip
                            // Se stage == 'concluded', mostra azul independente do status
                            return (
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {renderStatusDot(task.status, task.stage)}
                              </div>
                            );

                          case "percentage":
                            if (col.key === "percent_real" && inlineEditMode) {
                              return (
                                <div style={{ display: "flex", justifyContent: "center" }}>
                          <TextField
                            type="number"
                            size="small"
                            value={task.percent_real}
                            onChange={(e) =>
                              updateDeliverableField(
                                task.id,
                                "percent_real",
                                e.target.value
                              )
                            }
                            classes={{ root: classes.textFieldRoot }}
                            InputProps={{
                              inputProps: {
                                min: 0,
                                max: 100,
                                step: 1,
                                        pattern: "[0-9]*",
                                style: {
                                  textAlign: "center",
                                  fontSize: "11px",
                                },
                              },
                              classes: { input: classes.inputText },
                            }}
                            InputLabelProps={{
                              classes: { root: classes.labelText },
                              shrink: true,
                            }}
                            style={{ width: "50px", color: "#333" }}
                          />
                        </div>
                              );
                            }
                            return `${task[col.key]}%`;

                          case "number":
                            if (col.key === "totalDays") {
                              return calcTotalDays(task);
                            }
                            return task[col.key] || 0;

                          default:
                            if (col.key === "owner" && inlineEditMode) {
                              // Opções: apenas os owners reais
                              const ownerOptionsDefault = [...owners];
                              // Encontra o owner atual (ou null se não tiver)
                              const selectedOwnerDefault = task.responsible_id 
                                ? ownerOptionsDefault.find(u => u.id === task.responsible_id) || null
                                : null;
                              
                              return (
                                <Autocomplete
                                  size="small"
                                  options={ownerOptionsDefault}
                                  getOptionLabel={(option) => option?.name || ""}
                                  getOptionSelected={(option, value) => option?.id === value?.id}
                                  value={selectedOwnerDefault}
                                  onChange={(event, newValue) => {
                                    const userId = newValue?.id || null;
                                    const userName = newValue?.name || "";

                                    updateDeliverableField(
                                      task.id,
                                      "responsible_id",
                                      userId
                                    );

                                    updateDeliverableField(
                                      task.id,
                                      "owner",
                                      userName
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="standard"
                                      placeholder={selectedOwnerDefault ? "" : t("execution.search_owner")}
                                      classes={{ root: classes.textFieldRoot }}
                                      InputProps={{
                                        ...params.InputProps,
                                        classes: { input: classes.inputText },
                                        style: { fontSize: "11px" },
                                      }}
                                    />
                                  )}
                                  renderOption={(option) => (
                                    <span style={{ fontSize: "12px" }}>
                                      {option.name}
                                    </span>
                                  )}
                                  noOptionsText={t("execution.no_owner_found")}
                                  style={{ minWidth: "120px" }}
                                  clearOnEscape
                                />
                              );
                            }
                            return task[col.key] || "-";
                        }
                      };

                      return (
                        <td 
                          key={`${task.id}-${col.key}`} 
                          className={colIndex === 0 ? classes.ganttTableBody1st : classes.ganttTableBody}
                        >
                          {renderCellContent()}
                    </td>
                      );
                    })}

                    {/* Célula Actions - apenas quando não for modo somente leitura */}
                    {!readOnly && (
                      <td
                        className={classes.ganttTableBody} // Use a mesma classe das outras células para consistência
                        style={{
                          textAlign: "center", // Garante que o contêiner flex seja centralizado na célula
                        }}
                      >
                      {/* Flex container para alinhar todos os botões na horizontal */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        {/* Botão de Deletar - apenas quando não for modo somente leitura */}
                        {!readOnly && (
                          <Tooltip 
                            title={t("execution.delete")}
                            disablePortal={false}
                            style={{ zIndex: 10001 }}
                          >
                            {/* O span é importante para o Tooltip funcionar em botões desabilitados */}
                            <span>
                              <IconButton
                                size="small"
                                onClick={() => onDeleteTask(task.id)}
                                disabled={!inlineEditMode || isApproving}
                              >
                                <Delete
                                  fontSize="small"
                                  className={classes.iconButtonCustom} // Aplica o estilo customizado
                                  style={{
                                    color:
                                      !inlineEditMode || isApproving
                                        ? "#ccc"
                                        : "#3C4858",
                                  }} // Lógica de cor para desabilitado
                                />
                              </IconButton>
                            </span>
                          </Tooltip>
                        )}

                        {/* Botões de Aprovação/Rejeição - apenas quando não for modo somente leitura */}
                        {!readOnly && task.approval_status === "pending" && canApprove && (
                          <>
                            <Tooltip 
                              title={t("approvals.reject")}
                              disablePortal={false}
                              style={{ zIndex: 10001 }}
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    onApprovalAction(task.id, "reject")
                                  }
                                  disabled={isApproving}
                                >
                                  <Cancel
                                    fontSize="small"
                                    className={classes.iconButtonCustom}
                                    style={{
                                      color: isApproving ? "#ccc" : "#d32f2f",
                                    }}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>

                            <Tooltip 
                              title={t("approvals.approve")}
                              disablePortal={false}
                              style={{ zIndex: 10001 }}
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    onApprovalAction(task.id, "approve")
                                  }
                                  disabled={isApproving}
                                >
                                  <CheckCircle
                                    fontSize="small"
                                    className={classes.iconButtonCustom}
                                    style={{
                                      color: isApproving ? "#ccc" : "green",
                                    }}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </>
                        )}
                                              </div>
                      </td>
                    )}
                  </tr>
                );})}
              </tbody>
            </table>
          </div>

          {/*Timeline (now rolls together with the table in scroll x) */}
          <div style={{ flex: 1, overflowX: "auto" }}>
            <div style={{
              position: "relative",
              minWidth: `${periods.length * CELL_PX[viewMode]}px`,
            }}>
              <div style={{
                display: "grid",
                gridTemplateColumns: `repeat(${periods.length}, minmax(${CELL_PX[viewMode]}px, 1fr))`,
                gridTemplateRows: `${viewMode === "daily" || viewMode === "weekly" ? rowHeight + 8 : rowHeight}px repeat(${tasks.length}, ${rowHeight}px)`,
              }}>
                {/* Timeline header */}
                {periods.map((p, i) => (
                  <div
                    key={i}
                    style={{
                      gridColumn: `${i + 1} / span 1`,
                      gridRow: "1 / 1",
                      textAlign: "center",
                      fontSize: "11px",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#555555",
                      borderBottom: "1px solid #e0e0e0",
                      borderRight: "1px solid #e0e0e0",
                      padding: "6px 2px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "0",
                    }}
                  >
                    {viewMode === "daily" && (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.1' }}>
                        <div style={{ fontSize: '9px', marginBottom: '1px', opacity: '0.9' }}>{p.monthName}</div>
                        <div style={{ fontSize: '10px' }}>{p.dayName} {p.d}</div>
                      </div>
                    )}
                    {viewMode === "weekly" && (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.1' }}>
                        <div style={{ fontSize: '9px', marginBottom: '1px', opacity: '0.9' }}>{p.monthName}</div>
                        <div style={{ fontSize: '10px' }}>{p.weekStart}-{p.weekEnd}</div>
                      </div>
                    )}
                    {viewMode === "month" && `${t(`months.${p.m + 1}`).substring(0, 3)}'${String(p.y).slice(-2)}`}
                    {viewMode === "quarter" && `Q${p.q} ${p.y}`}
                    {viewMode === "year" && p.y}
                  </div>
                ))}

                {/* Gantt bars */}
                {tasks.map((task, rowIndex) => {
                  const isHovered = hoveredRowId === task.id;
                  const startPos = getGridPos(task.start);
                  const endPos = getGridPos(task.end);
                  
                  if (startPos === null || endPos === null) return null;
                  
                  return (
                    <div
                      key={task.id}
                                              style={{
                          gridColumn: `${startPos} / ${endPos + 1}`,
                          gridRow: `${rowIndex + 2} / span 1`,
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                          padding: "4px 0",
                          animation: `slideIn 0.5s ${rowIndex * 0.05}s ease-out backwards`,
                          zIndex: isHovered ? 20 : 1,
                        }}
                      onMouseEnter={() => setHoveredRowId(task.id)}
                      onMouseLeave={() => setHoveredRowId(null)}
                    >
                      <Tooltip 
                        title={`${task.text} - ${task.percent_real}%`}
                        disablePortal={false}
                        style={{ zIndex: 10001 }}
                      >
                        <div
                          onClick={(e) => {
                            if (readOnly) return; // Não executa no modo somente leitura
                            e.stopPropagation();
                            onTaskClick(task);
                          }}
                          style={{
                            width: "100%",
                            height: "100%",
                            minHeight: "20px", // Garante altura mínima visível
                            backgroundColor: task.fillColor,
                            color: task.textColor,
                            cursor: readOnly ? "default" : "pointer",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            padding: "0 8px",
                            fontSize: "11px",
                            overflow: "hidden",
                            fontWeight: 400,
                            transition: "all 0.2s ease-out",
                            filter: isHovered ? "brightness(1.1)" : "brightness(1)",
                          }}
                        >
                          <div
                            style={{
                              width: `${task.percent}%`,
                              height: "100%",
                              backgroundColor: task.progressColor,
                              position: "absolute",
                              top: 0,
                              left: 0,
                              borderRadius: "4px",
                              zIndex: 0,
                            }}
                          />
                          {/* Removed task.text from here - only shown in tooltip */}
                        </div>
                      </Tooltip>
                    </div>
                  );
                })}

                {/* Grid Lines & Hover effect */}
                {tasks.map((task, rowIndex) =>
                  periods.map((__, periodIndex) => (
                    <div
                      key={`${task.id}-${periodIndex}`}
                                                                                             style={{
                           gridColumn: `${periodIndex + 1} / span 1`,
                           gridRow: `${rowIndex + 2} / span 1`,
                           borderRight: "1px solid #f0f0f0",
                           borderBottom: "1px solid #f0f0f0",
                           zIndex: -1,
                           backgroundColor: hoveredRowId === task.id ? "#f5f5f5" : "transparent",
                           transition: "background-color 0.2s ease",
                         }}
                      onMouseEnter={() => setHoveredRowId(task.id)}
                      onMouseLeave={() => setHoveredRowId(null)}
                    />
                  )),
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Keyframes style */}
      <style>
        {` @keyframes slideIn { from { transform: translateX(-20px); opacity: 0; } to { transform: translateX(0); opacity: 1; } } `}
      </style>
    </>
  );
}

CustomGantt.propTypes = {
  tasks: PropTypes.array.isRequired,
  onTaskClick: PropTypes.func.isRequired,
  onDeleteTask: PropTypes.func.isRequired,
  onAddTask: PropTypes.func.isRequired,
  owners: PropTypes.array.isRequired,
  calcTotalDays: PropTypes.func.isRequired,
  inlineEditMode: PropTypes.bool.isRequired,
  updateDeliverableField: PropTypes.func.isRequired,
  stages: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  sortConfig: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.string,
  }).isRequired,
  onSort: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  translateStage: PropTypes.func.isRequired,
  readOnly: PropTypes.bool, // Novo parâmetro opcional
  renderStatusDot: PropTypes.func, // Passando a função como prop
  renderDeliverableName: PropTypes.func, // Passando a função como prop
  deliverablesLayout: PropTypes.object, // Nova prop para configuração de layout
  userDetails: PropTypes.object, // Prop para regras de status dos entregáveis
  dirtyRows: PropTypes.instanceOf(Set), // Linhas modificadas para feedback visual
};

/* ===================== Main Component: InitiativesExecution ===================== */
function InitiativesExecution({
  selectedInitiative,
  deliverablesData,
  classes,
  clientColor,
  canEdit,
}) {
  const { userDetails } = React.useContext(AuthContext);

  // Configuração de layout de deliverables baseada na implementação
  const deliverablesLayout = userDetails?.deliverables_layout || {
    table_columns: [
      {"key": "deliverable_name", "header_key": "execution.deliverables", "sortable": true, "type": "text"},
      {"key": "planned_start_date", "header_key": "execution.start", "sortable": true, "type": "date"},
      {"key": "planned_end_date", "header_key": "execution.end", "sortable": true, "type": "date"},
      {"key": "category", "header_key": "execution.category", "sortable": true, "type": "category"},
      {"key": "owner", "header_key": "execution.owner", "sortable": true, "type": "text"},
      {"key": "stage", "header_key": "execution.stage", "sortable": true, "type": "stage"},
      {"key": "percent_planned", "header_key": "execution.percent_planned", "sortable": true, "type": "percentage"},
      {"key": "percent_real", "header_key": "execution.percent_real", "sortable": true, "type": "percentage"},
      {"key": "totalDays", "header_key": "execution.total_days", "sortable": true, "type": "number"}
    ],
    progress_calculation: {
      type: "percentage", 
      description: "Calculation based on percent_planned vs percent_real"
    }
  };

  // Calcule a permissão de aprovação contextual AQUI
  const canApproveThisInitiative =
    // 1. O usuário tem a permissão genérica no seu Role?
    userDetails?.permissions?.can_approve_deliverables &&
    // 2. E...
    // 2a. O email do usuário é o mesmo do líder da iniciativa?
    (userDetails.email === selectedInitiative.leader_email ||
      // 2b. OU o email do usuário é o mesmo do PMO da iniciativa?
      userDetails.email === selectedInitiative.pmo_email);

  const [activeTab, setActiveTab] = useState("gantt");
  const [deliverables, setDeliverables] = useState([]);
  const [filterOwner, setFilterOwner] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterDeliverable, setFilterDeliverable] = useState("");
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editingDeliverable, setEditingDeliverable] = useState(null);
  const [inlineEditMode, setInlineEditMode] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "planned_end_date", direction: "asc" }); // Ordenação padrão por data de fim
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  const [owners, setOwners] = useState([]);
  const [dirtyRows, setDirtyRows] = useState(new Set()); // ids com edição
  const [deletedRows, setDeletedRows] = useState(new Set()); // ids marcados p/ exclusão
  const [isSaving, setIsSaving] = useState(false);
  const [isReloading, setIsReloading] = useState(false);
  //const [deliverablesData, setDeliverablesData] = useState(null);
  const [data, setData] = useState(null); // começa sem dados
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState({
    // novo
    percent_real: 0,
    percent_planned: 0,
    percent_diff: 0,
  });

  // Estados para insights de deliverables
  const [isDeliverableInsightsModalOpen, setIsDeliverableInsightsModalOpen] = useState(false);
  const [deliverableInsightsContent, setDeliverableInsightsContent] = useState("");
  const [isLoadingDeliverableInsights, setIsLoadingDeliverableInsights] = useState(false);
  const [isCopyingDeliverable, setIsCopyingDeliverable] = useState(false);

  const { t } = useTranslation();

  // Funções para insights de deliverables
  const handleOpenDeliverableInsights = async () => {
    if (!selectedInitiative?.id) {
      toast.error(t('deliverable_insights.no_initiative_selected'));
      return;
    }

    setIsDeliverableInsightsModalOpen(true);
    setIsLoadingDeliverableInsights(true);
    setDeliverableInsightsContent("");

    try {
      const response = await generateDeliverableInsights(selectedInitiative.id);
      
      if (response.success && response.text) {
        setDeliverableInsightsContent(response.text);
      } else {
        toast.error(t('deliverable_insights.error_loading'));
        setDeliverableInsightsContent(t('deliverable_insights.no_content'));
      }
    } catch (error) {
      console.error("Error fetching deliverable insights:", error);
      toast.error(t('deliverable_insights.error_loading'));
      setDeliverableInsightsContent(t('deliverable_insights.no_content'));
    } finally {
      setIsLoadingDeliverableInsights(false);
    }
  };

  const handleCloseDeliverableInsights = () => {
    setIsDeliverableInsightsModalOpen(false);
    setDeliverableInsightsContent("");
    setIsLoadingDeliverableInsights(false);
  };

  const handleCopyDeliverableToClipboard = async () => {
    if (!deliverableInsightsContent) return;
    
    setIsCopyingDeliverable(true);
    try {
      await navigator.clipboard.writeText(deliverableInsightsContent);
      toast.success(t('deliverable_insights.copied_success'));
    } catch (error) {
      console.error("Error copying to clipboard:", error);
      toast.error("Erro ao copiar para área de transferência");
    } finally {
      setIsCopyingDeliverable(false);
    }
  };

  // Função auxiliar para normalizar deliverables (aplicar defaults)
  const normalizeDeliverables = (deliverablesList) => {
    return (deliverablesList || []).map((d) => ({
      ...d,
      deliverable_id: d.deliverable_id ?? d.id,
      status: d.status || "on_track", // Status padrão é on_track
    }));
  };

  useEffect(() => {
    if (!deliverablesData) {
      setDeliverables([]);
      return;
    }
    setDeliverables(normalizeDeliverables(deliverablesData.deliverables));
    setSummary(
      deliverablesData.deliverables_summary || {
        percent_real: 0,
        percent_planned: 0,
        percent_diff: 0,
      }
    );
  }, [deliverablesData]);

  useEffect(() => {
    (async () => {
      const { data } = await client.post("/api/implementation_users/", {
        access_group_id: selectedInitiative?.access_group_id || null,
      });
      if (data.success) setOwners(data.users);
    })();
  }, [selectedInitiative]);

  //Filter Function: Includes Deliverable Name, Owner, Status and Stage
  const applyFilters = (ds) => {
    let out = [...ds];
    if (filterOwner) out = out.filter((d) => d.owner === filterOwner);
    // Para "concluded", filtrar pelo stage (concluído é determinado pelo estágio)
    if (filterStatus) {
      if (filterStatus === "concluded") {
        out = out.filter((d) => d.stage === "concluded");
      } else {
        // Para outros status, filtrar pelo status E excluir os concluídos
        out = out.filter((d) => d.status === filterStatus && d.stage !== "concluded");
      }
    }
    if (filterStage) out = out.filter((d) => d.stage === filterStage);
    if (filterDeliverable)
      out = out.filter((d) =>
        d.deliverable_name
          .toLowerCase()
          .includes(filterDeliverable.toLowerCase())
      );
    return out;
  };

  const filteredDeliverables = applyFilters(deliverables);

  //*****Summary card modification: Use filtered data *****
  const filteredTotal = filteredDeliverables.length;
  // Contagens de status excluem os que estão com stage == 'concluded'
  // (esses contam apenas no filteredConcludedCount)
  const filteredOnTrackCount = filteredDeliverables.filter(
    (d) => d.status === "on_track" && d.stage !== "concluded"
  ).length;
  const filteredAtRiskCount = filteredDeliverables.filter(
    (d) => d.status === "at_risk" && d.stage !== "concluded"
  ).length;
  const filteredDelayedCount = filteredDeliverables.filter(
    (d) => d.status === "delayed" && d.stage !== "concluded"
  ).length;
  // Concluído é determinado pelo ESTÁGIO, não pelo status
  const filteredConcludedCount = filteredDeliverables.filter(
    (d) => d.stage === "concluded"
  ).length;

  //Order the Deliverables according to Sortconfig
  const sortedDeliverables = useMemo(() => {
    let sorted = [...filteredDeliverables];
    if (sortConfig.key) {
      sorted.sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];
        //for dates, convert to Date
        if (
          sortConfig.key === "planned_start_date" ||
          sortConfig.key === "planned_end_date"
        ) {
          aVal = new Date(aVal);
          bVal = new Date(bVal);
        }
        //For total days, calculate the difference
        if (sortConfig.key === "totalDays") {
          aVal =
            (new Date(a.planned_end_date) - new Date(a.planned_start_date)) /
            (1000 * 60 * 60 * 24);
          bVal =
            (new Date(b.planned_end_date) - new Date(b.planned_start_date)) /
            (1000 * 60 * 60 * 24);
        }
        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sorted;
  }, [filteredDeliverables, sortConfig]);

  const stages = ["not_started", "in_progress", "on_hold", "concluded"];

  //*****MAPIFICATION IN TASK MAPPING: Use the "percent" of mock directly *****
  const tasks = sortedDeliverables.map((del) => {
    const percentReal = Number(del.percent_real);
    const percentPlanned = Number(del.percent_planned);
    const ratio =
      percentPlanned === 0 ? 0 : (percentReal / percentPlanned) * 100;
    let fillColor = "";
    let progressColor = "";
    // Se estágio for concluído, cor azul (independente do status)
    if (del.stage === "concluded") {
      fillColor = "#1E90FF"; // Dodger Blue for concluded stage
      progressColor = "#1565C0";
    } else if (del.status === "on_track") {
      fillColor = "green";
      progressColor = "#006400";
    } else if (del.status === "at_risk") {
      fillColor = "#F4C430";
      progressColor = "#cc5500";
    } else if (del.status === "delayed") {
      fillColor = "#E04F5F";
      progressColor = "#C42235";
    } else {
      // Cores padrão caso não haja status definido
      fillColor = "#3C4858";
      progressColor = "#2E3B4A";
    }

    return {
      id: del.deliverable_id || del.id || Math.random(),
      text: del.deliverable_name || "Deliverable sem nome",
      start: del.planned_start_date ? new Date(...parseDateArr(del.planned_start_date)) : new Date(),
      end: del.planned_end_date ? new Date(...parseDateArr(del.planned_end_date)) : new Date(),
      // Adicionar campos de data também como campos diretos para acesso na tabela
      planned_start_date: del.planned_start_date || "",
      planned_end_date: del.planned_end_date || "",
      duration: null,
      responsible_id: del.responsible_id || null,
      progress: ratio || 0,
      percent: percentReal || 0, // Campo necessário para o Gantt
      percent_planned: percentPlanned || 0,
      percent_real: percentReal || 0,
      type: "task",
      lazy: false,
      status: del.status || "not_started",
      fillColor: fillColor || "#2E3B4A",
      progressColor: progressColor || "#2E3B4A",
      textColor: "#ffffff",
      owner: del.owner || "",
      stage: del.stage || "not_started",
      category: del.category || "task",
      approval_status: del.approval_status || "approved",
      // Adicionar os novos campos ausentes
      launch_phase: del.launch_phase || "",
      is_critical: del.is_critical || false,
    };
  });

  //function for manipulation of the tasks
  const handleTaskClick = (task) => {
    // No modo de visualização (canEdit=false), não abre o drawer
    if (!canEdit) return;
    
    const found = deliverables.find((d) => d.deliverable_id === task.id);
    if (found) {
      setEditingDeliverable({ ...found });
      setOpenEditDialog(true);
    }
  };

  /* ---------- ADD ---------- */
  const handleAddTask = async () => {
    const payload = {
      initiative_id: selectedInitiative.id,
      deliverable_name: "",
      planned_start_date: new Date().toISOString().slice(0, 10),
      planned_end_date: new Date().toISOString().slice(0, 10),
      category: "task",
    };

    const { data } = await createDeliverable(payload);
    if (data.success) {
      setDeliverables((prev) => [
        ...prev,
        {
          ...payload,
          deliverable_id: data.deliverable_id,
          percent_real: 0,
          percent_planned: 0,
          stage: "not_started",
          status: "on_track",
        },
      ]);
      setInlineEditMode(true);
    }
  };

  /* ---------- INLINE UPDATE (campo único) ---------- */
  const updateDeliverableField = (id, field, value) => {
    setDeliverables((prev) =>
      prev.map((d) => {
        if (d.deliverable_id !== id) return d;
        
        // Validação de datas: fim deve ser >= início
        if (field === "planned_end_date" && d.planned_start_date && value) {
          if (new Date(value) < new Date(d.planned_start_date)) {
            toast.warning(t("execution.date_validation_error"));
            return d; // Não atualiza se a data de fim for anterior à de início
          }
        }
        if (field === "planned_start_date" && d.planned_end_date && value) {
          if (new Date(value) > new Date(d.planned_end_date)) {
            toast.warning(t("execution.date_validation_error"));
            return d; // Não atualiza se a data de início for posterior à de fim
          }
        }
        
        return { ...d, [field]: value };
      })
    );
    setDirtyRows((prev) => new Set(prev).add(id)); // marca como alterado
  };

  /* ---------- DELETE ---------- */
  const handleDeleteTask = async (id) => {
    // remove da lista visual
    setDeliverables((prev) => prev.filter((d) => d.deliverable_id !== id));
    // marca para exclusão
    setDeletedRows((prev) => new Set(prev).add(id));
    // se o registro já estava sujo, remove da lista de edits
    setDirtyRows((prev) => {
      const cp = new Set(prev);
      cp.delete(id);
      return cp;
    });
  };

  //Board: Uses the filtered delverables for display
  const onDragEnd = (result) => {
    // No modo somente leitura, não permite transições
    if (!canEdit) return;
    
    if (!result.destination) return;
    const itemId = Number(result.draggableId);
    const idx = deliverables.findIndex((d) => d.deliverable_id === itemId);
    if (idx === -1) return;
    const newStage = result.destination.droppableId;
    const updated = [...deliverables];
    updated[idx] = { ...updated[idx], stage: newStage };
    setDeliverables((prev) =>
      prev.map((d) =>
        d.deliverable_id === itemId ? { ...d, stage: newStage } : d
      )
    );
    updateDeliverable({ deliverable_id: itemId, stage: newStage }).catch((e) =>
      console.error("drag save failed", e)
    );
  };

  const handleSaveEdit = async () => {
    setIsSaving(true);
    
    try {
      // 1) Processar atualizações SEQUENCIALMENTE para evitar race conditions
      const dirtyRowsArray = Array.from(dirtyRows);
      for (const id of dirtyRowsArray) {
        const row = deliverables.find((d) => d.deliverable_id === id);
        if (!row) continue;
        
        await updateDeliverable({
          deliverable_id: id,
          deliverable_name: row.deliverable_name,
          planned_start_date: row.planned_start_date,
          planned_end_date: row.planned_end_date,
          stage: row.stage,
          category: row.category,
          percent_real: row.percent_real,
          responsible_id: row.responsible_id,
          description: row.description,
          launch_phase: row.launch_phase,
          is_critical: row.is_critical,
          status: row.status || "on_track",
        });
      }

      // 2) Processar exclusões SEQUENCIALMENTE
      const deletedRowsArray = Array.from(deletedRows);
      for (const id of deletedRowsArray) {
        await deleteDeliverable(id);
      }

      setInlineEditMode(false);
      setDirtyRows(new Set());
      setDeletedRows(new Set());
      setIsSaving(false);
      setIsReloading(true);
      // buscar os dados atualizados
      const { data } = await client.post("/api/initiative_deliverables/", {
        action: "list",
        initiative_id: selectedInitiative.id,
      });
      setDeliverables(normalizeDeliverables(data.deliverables));
      setSummary(data.deliverables_summary);
      setIsReloading(false);
    } catch (err) {
      console.error("Falha ao salvar deliverables:", err);
      toast.error(t("errors.failed_to_save"));
      setIsSaving(false);
    }
  };

  const handleDrawerSave = async () => {
    if (!editingDeliverable) return;
    setIsSaving(true);
    await updateDeliverable({
      deliverable_id: editingDeliverable.deliverable_id,
      deliverable_name: editingDeliverable.deliverable_name,
      planned_start_date: editingDeliverable.planned_start_date,
      planned_end_date: editingDeliverable.planned_end_date,
      stage: editingDeliverable.stage,
      category: editingDeliverable.category,
      percent_real: editingDeliverable.percent_real,
      description: editingDeliverable.description,
      responsible_id: editingDeliverable.responsible_id,
    });

    // reflete na lista em memória
    setDeliverables((ds) =>
      ds.map((d) =>
        d.deliverable_id === editingDeliverable.deliverable_id
          ? { ...editingDeliverable }
          : d
      )
    );
    setOpenEditDialog(false);
    setIsSaving(false);
    setIsReloading(true);
    // buscar os dados atualizados
    const { data } = await client.post("/api/initiative_deliverables/", {
      action: "list",
      initiative_id: selectedInitiative.id,
    });
    setDeliverables(normalizeDeliverables(data.deliverables));
    setSummary(data.deliverables_summary);
    setIsReloading(false);
  };

  //State and Handlers for Cancel Dialog (when clicking the X button when in editing mode)
  const handleOpenCancelDialog = () => {
    setIsCancelDialogOpen(true);
  };
  const handleCloseCancelDialog = () => {
    setIsCancelDialogOpen(false);
  };
  const handleConfirmCancel = () => {
    setDeliverables(normalizeDeliverables(deliverablesData.deliverables)); // volta dados do servidor
    setInlineEditMode(false);
    setDirtyRows(new Set());
    setDeletedRows(new Set());
    setIsCancelDialogOpen(false);
  };

  //Auxiliary Function for Date Para
  function parseDateArr(str) {
    if (!str) return [2023, 0, 1];
    const [year, month, day] = str.split("-");
    const y = parseInt(year, 10);
    const m = parseInt(month, 10) - 1;
    const d = parseInt(day, 10);
    if (isNaN(y) || isNaN(m) || isNaN(d)) return [2023, 0, 1];
    return [y, m, d];
  }

  //Handlers for clickable filters
  const handleStatusFilter = (status) => {
    setFilterStatus((prev) => (prev === status ? "" : status));
  };

  //Handler para clear filters
  const handleClearFilters = () => {
    setFilterOwner("");
    setFilterStatus("");
    setFilterStage("");
    setFilterDeliverable("");
  };

  //is trading para black
  const handleSort = (columnKey) => {
    if (sortConfig.key === columnKey) {
      // Toggle direction
      setSortConfig({
        key: columnKey,
        direction: sortConfig.direction === "asc" ? "desc" : "asc",
      });
    } else {
      setSortConfig({ key: columnKey, direction: "asc" });
    }
  };

  function translateCategoryExcel(category) {
    if (!category) return ""; // proteção
    const lower = String(category).toLowerCase();

    if (lower === "task") return t("execution.category_task");
    if (lower === "risk") return t("execution.category_risk");
    return category; // fallback
  }
  //const [openFullscreen, setOpenFullscreen] = React.useState(false);

  const exportToExcel = () => {
    //1) Mount the file name: [InitiativeName] _ [Date Time] _ [Sheetname] .xlsx
    //Remove invalid characters and limit size if necessary
    const rawInitName = selectedInitiative?.initiative || "Initiative";
    const safeInitName = rawInitName.replace(/[\\/:*?"<>|]/g, ""); // Removes illegal on Windows
    const shortInitName =
      safeInitName.length > 30 ? safeInitName.slice(0, 30) : safeInitName;
    //2) Prepare data (including category)
    //assuming you have a translatecategory (category) function or use category directly
    const dataRows = filteredDeliverables.map((d) => [
      rawInitName,
      d.deliverable_name,
      d.planned_start_date,
      d.planned_end_date,
      d.owner,
      translateCategoryExcel(d.category),
      translateStage(d.stage),
      d.percent_planned,
      d.percent_real,
      Math.ceil(
        (new Date(d.planned_end_date) - new Date(d.planned_start_date)) /
          (1000 * 60 * 60 * 24)
      ),
    ]);

    // 3) Set Up columns
    const columns = [
      t("execution.initiative_name"),
      t("execution.deliverables"),
      t("execution.start"),
      t("execution.end"),
      t("execution.owner"),
      t("execution.category"),
      t("execution.stage"),
      t("execution.percent_planned"),
      t("execution.percent_real"),
      t("execution.total_days"),
    ];
    // 4) Create Customized Header
    const headerTitle = t("execution.implementation_plan");
    const wsData = [];
    // Line 1: Title
    wsData.push([headerTitle]);
    //Line 2: blank
    wsData.push([]);
    //Line 3: Column names
    wsData.push(columns);
    //Subsequent lines: Data
    wsData.push(...dataRows);

    // 5) Converter para sheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    const sheetName = t("execution.implementation_plan");
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const hh = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    const dateStr = `${yyyy}${mm}${dd}_${hh}${min}`;

    let fileName = `${shortInitName}_${dateStr}_${sheetName}.xlsx`;
    if (fileName.length > 100) {
      fileName = fileName.slice(0, 100) + ".xlsx";
    }

    // Mix from A1 to the last column of the title
    ws["!merges"] = ws["!merges"] || [];
    ws["!merges"].push({
      s: { r: 0, c: 0 },
      e: { r: 0, c: columns.length - 1 },
    });

    // 6)Head
    const clientColor = classes.clientColor || "#000";
    const getFontColorForBackground = (hexColor) => {
      hexColor = hexColor.replace("#", "");
      const r = parseInt(hexColor.substring(0, 2), 16);
      const g = parseInt(hexColor.substring(2, 4), 16);
      const b = parseInt(hexColor.substring(4, 6), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 155 ? "000000" : "FFFFFF";
    };
    const fontColor = getFontColorForBackground(clientColor);
    if (ws["A1"]) {
      ws["A1"].s = {
        fill: { fgColor: { rgb: clientColor.replace("#", "").toUpperCase() } },
        font: { color: { rgb: fontColor }, bold: true, sz: 16 },
        alignment: { horizontal: "center", vertical: "center" },
      };
    }

    // Width of each column
    ws["!cols"] = columns.map(() => ({ wch: 20 }));

    // Hide Gridlines
    ws["!sheetViews"] = [{ showGridLines: false }];

    // 7) Create Workbook

    // 8)Download the file
    XLSX.writeFile(wb, fileName);
  };

  // Função para calcular readiness baseado nos deliverables
  const calculateReadiness = () => {
    const mvpDeliverables = deliverables.filter(d => d.launch_phase === 'mvp');
    const mvpConcluded = mvpDeliverables.filter(d => d.stage === 'concluded');
    const totalConcluded = deliverables.filter(d => d.stage === 'concluded');

    const mvpReadiness = mvpDeliverables.length > 0 
      ? Math.round((mvpConcluded.length / mvpDeliverables.length) * 100) 
      : 0;
    
    const launchReadiness = deliverables.length > 0 
      ? Math.round((totalConcluded.length / deliverables.length) * 100) 
      : 0;

    return { mvpReadiness, launchReadiness };
  };

  // Determinar valor e cor da progress bar baseado na configuração
  const getProgressData = () => {
    if (deliverablesLayout?.progress_calculation?.type === "readiness") {
      const { mvpReadiness, launchReadiness } = calculateReadiness();
      
      return {
        value: launchReadiness,
        color: launchReadiness < 60 ? "#E04F5F" : launchReadiness < 80 ? "#F4C430" : "green",
        label: t("execution.readiness_calculation"),
        mvpReadiness,
        launchReadiness,
        type: "readiness"
      };
    } else if (userDetails?.deliverable_status_source === "manual") {
      // Modo manual: % de entregáveis concluídos (por estágio) / total
      const totalDeliverables = deliverables.length;
      const concludedDeliverables = deliverables.filter(d => d.stage === "concluded").length;
      const percentConcluded = totalDeliverables > 0 
        ? Math.round((concludedDeliverables / totalDeliverables) * 100) 
        : 0;
      
      return {
        value: percentConcluded,
        color: percentConcluded < 50 ? "#E04F5F" : percentConcluded < 80 ? "#F4C430" : "green",
        label: t("execution.percent_concluded"),
        concludedCount: concludedDeliverables,
        totalCount: totalDeliverables,
        type: "manual"
      };
    } else {
      // Modo padrão: percentage (calculado)
      return {
        value: summary.percent_real,
        color: summary.percent_diff < 97 ? "#E04F5F" : summary.percent_diff < 100 ? "#F4C430" : "green",
        label: t("execution.percent_initiative"),
        targetPercent: summary.percent_planned,
        diffPercent: summary.percent_diff,
        type: "calculated"
      };
    }
  };

  const progressData = getProgressData();

  //function to translate the value of the stage
  function translateStage(stage) {
    const mapping = {
      not_started: t("execution.not_started"),
      in_progress: t("execution.in_progress"),
      concluded: t("execution.concluded"),
      on_hold: t("execution.on_hold"),
    };
    return mapping[stage] || stage;
  }

  // Function to render status indicator dot
  // Se stage == 'concluded', mostra azul independente do status
  const renderStatusDot = (status, stage = null) => {
    let color = "#3C4858"; // default color
    let tooltip = "";
    
    // Se estágio for concluído, círculo azul (independente do status)
    if (stage === "concluded") {
      color = "#1E90FF"; // Dodger Blue for concluded stage
      tooltip = t("execution.concluded");
    } else if (status === "on_track") {
      color = "green";
      tooltip = t("execution.on_track");
    } else if (status === "at_risk") {
      color = "#F4C430";
      tooltip = t("execution.at_risk");
    } else if (status === "delayed") {
      color = "#E04F5F";
      tooltip = t("execution.delayed");
    }
    
    return (
      <span
        style={{
          display: "inline-block",
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: color,
          marginRight: "10px",
          flexShrink: 0,
          boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
          border: "1px solid rgba(255,255,255,0.3)",
        }}
        title={tooltip}
      />
    );
  };

  // Function to truncate the name of deliverable for 40 characters with tooltip
  const renderDeliverableName = (name) => {
    if (name.length > 30) {
      return (
        <Tooltip 
          title={name}
          disablePortal={false}
          style={{ zIndex: 10001 }}
        >
          <span>{name.substring(0, 30)}...</span>
        </Tooltip>
      );
    }
    return name;
  };

  const totalColor =
    filteredDelayedCount > 0
      ? "#E04F5F"
      : filteredAtRiskCount > 0
        ? "#F4C430"
        : filteredOnTrackCount > 0
          ? "green"
          : filteredConcludedCount > 0
            ? "#1E90FF"
            : "#3C4858";

  const [isApproving, setIsApproving] = useState(false); // Novo estado para loading

  const handleApprovalAction = async (deliverableId, action) => {
    setIsApproving(true);
    try {
      await performApprovalAction({ deliverable_id: deliverableId, action });

      // Recarregar dados
      const { data } = await client.post("/api/initiative_deliverables/", {
        action: "list",
        initiative_id: selectedInitiative.id,
      });
      setDeliverables(normalizeDeliverables(data.deliverables));
      setSummary(data.deliverables_summary);
      toast.success(t("approvals.action_successful"));
    } catch (error) {
      console.error("Approval action failed:", error);
      toast.error(t("errors.action_failed"));
    } finally {
      setIsApproving(false);
    }
  };

  const handleApproveAll = async () => {
    setIsApproving(true);
    try {
      await approveAllDeliverables(selectedInitiative.id);

      toast.success(t("approvals.all_approved"));
      // Recarregar os dados
      const { data } = await client.post("/api/initiative_deliverables/", {
        action: "list",
        initiative_id: selectedInitiative.id,
      });
      setDeliverables(normalizeDeliverables(data.deliverables));
      setSummary(data.deliverables_summary);
    } catch (error) {
      console.error("Approve all failed:", error);
      toast.error(t("errors.action_failed"));
    } finally {
      setIsApproving(false);
    }
  };

  if (!deliverablesData || isReloading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <ThreeDots
          color={clientColor}
          height={80}
          width={80}
          ariaLabel="loading"
        />
      </div>
    );
  }

  return (
    <div style={{ padding: "5px" }}>
      {/*Summary and buttons */}
      <GridContainer style={{ marginBottom: "30px" }} spacing={1}>
        <GridItem xs={12} md={12} style={{ marginBottom: "10px" }}>
          <Card className={classes.summaryCard} style={{ minHeight: "140px" }}>
            {/* New block of % implementation */}
            <div
              style={{
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column", // Organiza os itens verticalmente
                alignItems: "center", // Centraliza o conteúdo
              }}
            >
              {/* Título acima do progresso */}
              <Typography
                variant="body2"
                style={{
                  fontWeight: "400",
                  color: "#3C4858",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                {progressData.label}
              </Typography>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end", // Alinha o Box na parte inferior
                }}
              >
                <Tippy
                  content={
                    progressData.type === "readiness"
                      ? `${t("execution.launch_readiness")}: ${progressData.launchReadiness}% | ${t("execution.mvp_readiness")}: ${progressData.mvpReadiness}%`
                      : progressData.type === "manual"
                        ? `${progressData.concludedCount} ${t("execution.of")} ${progressData.totalCount} ${t("execution.concluded").toLowerCase()}`
                        : `${progressData.diffPercent}% ${t("execution.of_target")}`
                  }
                  arrow={true}
                  theme="light"
                  zIndex={10002}
                  appendTo={() => document.body}
                  popperOptions={{
                    modifiers: [
                      {
                        name: 'zIndex',
                        enabled: true,
                        phase: 'write',
                        fn: ({ state }) => {
                          state.styles.popper.zIndex = '10002';
                        }
                      }
                    ]
                  }}
                >
                  <div
                    className={classes.chartWrapper}
                    style={{ width: "70px", height: "70px" }}
                  >
                    <CircularProgressbar
                      value={progressData.value}
                      text={`${progressData.value}%`}
                      strokeWidth={10}
                      styles={buildStyles({
                        textSize: "25px",
                        textColor: "#000",
                        pathColor: progressData.color,
                        trailColor: "#e0e0e0",
                      })}
                    />
                  </div>
                </Tippy>

                {/* Box posicionado no bottom - mostrar informações adequadas baseado no tipo */}
                <Box style={{ marginLeft: "10px", alignSelf: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    {progressData.type === "readiness" ? (
                      // Modo readiness: mostrar breakdown de MVP e Launch
                      <>
                        <div style={{ textAlign: "right" }}>
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: "400",
                              color: "#3C4858",
                              fontSize: "11px",
                            }}
                          >
                            {t("execution.mvp_readiness")}
                          </Typography>
                        </div>

                        <div style={{ textAlign: "left" }}>
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: "400",
                              color: "#3C4858",
                              fontSize: "13px",
                            }}
                          >
                            {progressData.mvpReadiness}%
                          </Typography>
                        </div>
                      </>
                    ) : progressData.type === "manual" ? (
                      // Modo manual: mostrar contagem de concluídos / total
                      <>
                        <div style={{ textAlign: "right" }}>
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: "400",
                              color: "#3C4858",
                              fontSize: "11px",
                            }}
                          >
                            {t("execution.concluded")}
                          </Typography>
                        </div>

                        <div style={{ textAlign: "left" }}>
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: "400",
                              color: "#3C4858",
                              fontSize: "13px",
                            }}
                          >
                            {progressData.concludedCount}/{progressData.totalCount}
                          </Typography>
                        </div>
                      </>
                    ) : (
                      // Modo calculated: mostrar vs target
                      <>
                    <div style={{ textAlign: "right" }}>
                      <Typography
                        variant="body2"
                        style={{
                          fontWeight: "400",
                          color: "#3C4858",
                          fontSize: "11px",
                        }}
                      >
                        {t("execution.vs_target")}
                      </Typography>
                    </div>

                    <div style={{ textAlign: "left" }}>
                      <Typography
                        variant="body2"
                        style={{
                          fontWeight: "400",
                          color: "#3C4858",
                          fontSize: "13px",
                        }}
                      >
                            {progressData.targetPercent}%
                      </Typography>
                    </div>
                      </>
                    )}
                  </div>
                </Box>
              </div>
            </div>

            <div
              style={{
                height: "80px",
                borderRight: "1px dashed rgba(0, 0, 0, 0.3)",
                margin: "0 3px",
              }}
            ></div>
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
                paddingLeft: "3px",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <Typography
                  variant="body2"
                  style={{
                    fontWeight: "400",
                    color: "#3C4858",
                    fontSize: "11px",
                  }}
                >
                  {t("execution.total")}
                </Typography>
                <Typography
                  variant="body2"
                  style={{ fontWeight: "400", color: "#3C4858" }}
                >
                  {t("execution.deliverables")}
                </Typography>
              </div>

              <Typography
                variant="h4"
                style={{ fontWeight: "500", color: totalColor }}
              >
                {filteredTotal}
              </Typography>
            </div>
            {/* Círculo Azul - Concluídos (por estágio) */}
            <div
              style={{
                cursor: "pointer",
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => handleStatusFilter("concluded")}
            >
              <span
                className={classes.circleIndicator}
                style={{ backgroundColor: "#1E90FF" }}
              />
              <Typography
                variant="h6"
                style={{ fontWeight: "500", color: "#3C4858" }}
              >
                {filteredConcludedCount}
              </Typography>
            </div>
            {/* Círculo Verde - On Track */}
            <div
              style={{
                cursor: "pointer",
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => handleStatusFilter("on_track")}
            >
              <span
                className={classes.circleIndicator}
                style={{ backgroundColor: "green" }}
              />
              <Typography
                variant="h6"
                style={{ fontWeight: "500", color: "#3C4858" }}
              >
                {filteredOnTrackCount}
              </Typography>
            </div>
            {/* Círculo Amarelo - At Risk */}
            <div
              style={{
                cursor: "pointer",
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => handleStatusFilter("at_risk")}
            >
              <span
                className={classes.circleIndicator}
                style={{ backgroundColor: "#F4C430" }}
              />
              <Typography
                variant="h6"
                style={{ fontWeight: "500", color: "#3C4858" }}
              >
                {filteredAtRiskCount}
              </Typography>
            </div>
            {/* Círculo Vermelho - Delayed */}
            <div
              style={{
                cursor: "pointer",
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => handleStatusFilter("delayed")}
            >
              <span
                className={classes.circleIndicator}
                style={{ backgroundColor: "#E04F5F" }}
              />
              <Typography
                variant="h6"
                style={{ fontWeight: "500", color: "#3C4858" }}
              >
                {filteredDelayedCount}
              </Typography>
            </div>
          </Card>
        </GridItem>
      </GridContainer>

      {/*Filter session */}
      <GridContainer
        style={{
          marginBottom: "8px",
          marginTop: "10px",
          flexWrap: isSmallScreen ? "wrap" : "nowrap",
          alignItems: "center",
        }}
      >
        <GridItem
          sm={12}
          md={6}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            <div
              style={{
                position: "relative",
                display: "inline-block",
                marginRight: "-10px",
              }}
            >
              <Tooltip 
                title={t("filters.clear_all")}
                disablePortal={false}
                style={{ zIndex: 10001 }}
              >
                <FontAwesomeIcon
                  onClick={handleClearFilters}
                  icon={faFilter}
                  style={{
                    marginRight: "16px",
                    fontSize: "20px",
                    color: "#666",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
              <div className={classes.clearFilters}>X</div>
            </div>
            <div
              style={{
                flex: 1,
                padding: "0px 3px 7px 0px",
                minWidth: "200px",
                marginLeft: "10px",
                flexWrap: "wrap",
              }}
            >
              <TextField
                fullWidth
                label={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {t("execution.deliverable_name")}
                    <Search className={classes.searchIcon} />
                  </div>
                }
                size="small"
                classes={{ root: classes.textFieldRoot }}
                InputProps={{
                  classes: { input: classes.inputText },
                  style: { fontSize: "12px" },
                }}
                InputLabelProps={{
                  classes: { root: classes.labelText },
                  shrink: true,
                }}
                value={filterDeliverable}
                onChange={(e) => setFilterDeliverable(e.target.value)}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </GridItem>
        <GridItem
          sm={12}
          md={5}
          style={{
            display: "flex",
            justifyContent: isSmallScreen ? "flex-start" : "center",
            alignItems: "center",
            marginTop: isSmallScreen ? "2px" : "0",
          }}
        >
          <div
            style={{
              minWidth: "100%",
              marginTop: isSmallScreen ? "7px" : "8px",
              flexShrink: 0,
              display: "flex",
              gap: "10px",
              justifyContent: isSmallScreen ? "flex-start" : "center",
            }}
          >
            <FormControl
              fullWidth
              className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
            >
              <Select
                value={filterStage}
                label={t("execution.stage")}
                onChange={(e) => setFilterStage(e.target.value)}
                size="small"
                displayEmpty
                classes={{
                  select: `${classes.select} ${classes.selectFormControlOverride}`,
                }}
              >
                <MenuItem
                  value=""
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                >
                  {t("execution.all_stages")}
                </MenuItem>
                {stages.map((st) => (
                  <MenuItem
                    key={st}
                    value={st}
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected,
                    }}
                  >
                    {translateStage(st)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
              style={{ marginLeft: "10px" }} // opcional, para espaçamento visual
            >
              <Select
                value={filterOwner}
                label={t("execution.owner")}
                onChange={(e) => setFilterOwner(e.target.value)}
                size="small"
                displayEmpty
                classes={{
                  select: `${classes.select} ${classes.selectFormControlOverride}`,
                }}
              >
                <MenuItem
                  value=""
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                >
                  {t("execution.all_owners")}
                </MenuItem>
                {owners.map((u) => (
                  <MenuItem
                    key={u.id}
                    value={u.name}
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected,
                    }}
                  >
                    {u.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </GridItem>
        <GridItem
          xs={12}
          md={2}
          style={{
            display: "flex",
            justifyContent: isSmallScreen ? "center" : "flex-end",
            alignItems: "center",
            marginTop: isSmallScreen ? "10px" : "0",
          }}
        >
          <div
            style={{
              color: "#3C4858",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "6px",
              marginRight: "3px",
              boxSizing: "border-box",
              overflowX: "hidden",
            }}
          >
            {canApproveThisInitiative &&
              deliverables.some((d) => d.approval_status === "pending") && (
                <Tooltip 
                  title={t("approvals.approve_all")}
                  disablePortal={false}
                  style={{ zIndex: 10001 }}
                >
                  <ChecklistRtlIcon
                    className={classes.iconButtonCustom}
                    onClick={handleApproveAll}
                    disabled={isApproving}
                    style={{ cursor: "pointer", fontSize: "25px" }}
                  >
                    {isApproving ? (
                      <ThreeDots color={clientColor} height={15} width={15} />
                    ) : (
                      t("approvals.approve_all_button")
                    )}
                  </ChecklistRtlIcon>
                </Tooltip>
              )}
            <Tooltip 
              title={t("execution.download_excel")}
              disablePortal={false}
              style={{ zIndex: 10001 }}
            >
              <SaveAlt
                style={{ cursor: "pointer", fontSize: "25px" }}
                className={classes.iconButtonCustom}
                onClick={exportToExcel}
              />
            </Tooltip>
            {canEdit && (
              <>
                {inlineEditMode ? (
                  <Tooltip 
                    title={t("execution.cancel_edit")}
                    disablePortal={false}
                    style={{ zIndex: 10001 }}
                  >
                    <CloseIcon
                      className={classes.iconButtonCustom}
                      style={{ cursor: "pointer", fontSize: "20px" }}
                      onClick={handleOpenCancelDialog}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip 
                    title={t("execution.edit")}
                    disablePortal={false}
                    style={{ zIndex: 10001 }}
                  >
                    <Edit
                      className={classes.iconButtonCustom}
                      style={{ cursor: "pointer", fontSize: "20px" }}
                      onClick={() => setInlineEditMode(true)}
                    />
                  </Tooltip>
                )}
                <Tooltip 
                  title={t("execution.add_deliverable")}
                  disablePortal={false}
                  style={{ zIndex: 10001 }}
                >
                  <AddCircle
                    className={classes.iconButtonCustom}
                    style={{ cursor: "pointer", fontSize: "20px" }}
                    onClick={handleAddTask}
                  />
                </Tooltip>
                <Tooltip 
                  title={t("execution.save")}
                  disablePortal={false}
                  style={{ zIndex: 10001 }}
                >
                  {isSaving ? (
                    <ThreeDots
                      color="#000"
                      height={18}
                      width={18}
                      ariaLabel="loading"
                    />
                  ) : (
                    <Save
                      className={classes.iconButtonCustom}
                      style={{
                        cursor:
                          inlineEditMode && !isSaving ? "pointer" : "default",
                        fontSize: "20px",
                      }}
                      onClick={handleSaveEdit}
                      disabled={!inlineEditMode || isSaving}
                    />
                  )}
                </Tooltip>
              </>
            )}
          </div>
        </GridItem>
      </GridContainer>

      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={(e, val) => setActiveTab(val)}
        indicatorColor="primary"
        textColor="primary"
        style={{ margin: "10px -7px" }}
        classes={{ root: classes.tabsRoot, indicator: classes.indicator }}
        variant="fullWidth"
      >
        <Tab
          label={t("execution.tab_gantt")}
          value="gantt"
          classes={{ root: classes.tabRoot }}
        />
        <Tab
          label={t("execution.tab_board")}
          value="board"
          classes={{ root: classes.tabRoot }}
        />
      </Tabs>

      {activeTab === "gantt" && (
        <>
          <CustomGantt
            tasks={tasks}
            owners={owners}
            onTaskClick={handleTaskClick}
            onDeleteTask={handleDeleteTask}
            onAddTask={handleAddTask}
            calcTotalDays={(task) => {
              const diffTime = Math.abs(task.end - task.start);
              return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            }}
            inlineEditMode={inlineEditMode && canEdit}
            updateDeliverableField={updateDeliverableField}
            stages={stages}
            classes={classes}
            sortConfig={sortConfig}
            onSort={handleSort}
            t={t}
            translateStage={translateStage}
            canApprove={canApproveThisInitiative}
            onApprovalAction={handleApprovalAction}
            isApproving={isApproving}
            readOnly={!canEdit} // Modo somente leitura quando não pode editar
            renderStatusDot={renderStatusDot} // Passando a função como prop
            renderDeliverableName={renderDeliverableName} // Passando a função como prop
            deliverablesLayout={deliverablesLayout} // Nova prop para configuração de layout
            userDetails={userDetails} // Prop necessária para o ícone Info das regras de status
            dirtyRows={dirtyRows} // Linhas modificadas para feedback visual
          />
        </>
      )}

      {activeTab === "board" && (
        <DragDropContext onDragEnd={onDragEnd} enableDefaultAnimations={canEdit}>
          <div
            style={{
              display: "flex",
              gap: "20px",
              padding: "3px 0",
              overflowX: "auto",
            }}
          >
            {stages.map((stageKey) => {
              const columnItems = applyFilters(deliverables).filter(
                (d) => d.stage === stageKey
              );
              return (
                <Droppable droppableId={stageKey} key={stageKey} isDropDisabled={!canEdit}>
                  {(provided) => (
                    <div
                      className={classes.boardColumn}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      <Typography
                        variant="body1"
                        className={classes.boardColumnHeader}
                      >
                        {translateStage(stageKey)}
                      </Typography>
                      {[...columnItems]
                        .sort((a, b) => {
                          const statusOrder = {
                            delayed: 1,
                            at_risk: 2,
                            on_track: 3,
                          };
                          const sA = statusOrder[a.status] || 99;
                          const sB = statusOrder[b.status] || 99;
                          if (sA !== sB) return sA - sB;
                          return (
                            new Date(a.planned_start_date) -
                            new Date(b.planned_start_date)
                          );
                        })
                        .map((del, index) => (
                          <Draggable
                            key={del.deliverable_id}
                            draggableId={String(del.deliverable_id)}
                            index={index}
                            isDragDisabled={!canEdit}
                          >
                            {(dragProvided) => (
                              <div
                                className={classes.cardItem}
                                ref={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                {...dragProvided.dragHandleProps}
                                onClick={() => {
                                  // No modo somente leitura, não abre o drawer
                                  if (!canEdit) return;
                                  
                                  setEditingDeliverable({ ...del });
                                  setOpenEditDialog(true);
                                }}
                                style={{
                                  borderTop: `4px solid ${
                                    del.stage === "concluded"
                                      ? "#1E90FF"
                                      : del.status === "on_track"
                                        ? "green"
                                        : del.status === "at_risk"
                                          ? "#F4C430"
                                          : del.status === "delayed"
                                            ? "#E04F5F"
                                            : "transparent"
                                  }`,
                                  cursor: canEdit ? "pointer" : "default",
                                  ...dragProvided.draggableProps.style,
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  style={{ fontWeight: 500, fontSize: "13px" }}
                                >
                                  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                    {del.approval_status === "pending" && (
                                      <HourglassEmpty
                                        style={{
                                          color: "#F4C430",
                                          fontSize: 14,
                                          marginRight: 4,
                                          verticalAlign: "middle",
                                        }}
                                      />
                                    )}
                                    {renderStatusDot(del.status, del.stage)}
                                    <span style={{ flex: 1 }}>
                                      {renderDeliverableName(del.deliverable_name)}
                                    </span>
                                  </div>
                                </Typography>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  style={{
                                    fontSize: "9.5px",
                                    marginTop: "3px",
                                  }}
                                >
                                  {t("execution.owner")}: {del.owner}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  style={{ fontSize: "9.5px" }}
                                >
                                  {t("execution.start")}:{" "}
                                  {(() => {
                                    const date = new Date(
                                      del.planned_start_date
                                    );
                                    return `${date.getDate().toString().padStart(2, "0")}-${t(`months.${date.getMonth() + 1}`)}-${date.getFullYear()}`;
                                  })()}{" "}
                                  | {t("execution.end")}:{" "}
                                  {(() => {
                                    const date = new Date(del.planned_end_date);
                                    return `${date.getDate().toString().padStart(2, "0")}-${t(`months.${date.getMonth() + 1}`)}-${date.getFullYear()}`;
                                  })()}
                                </Typography>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              );
            })}
          </div>
        </DragDropContext>
      )}

      {/*Editing dialog */}
      <Drawer
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        anchor="right"
        classes={{ paper: classes.drawerTasks }}
        BackdropProps={{
          style: { backgroundColor: "#000", opacity: "0.1" },
        }}
        PaperProps={{
          style: {
            borderRadius: "10px",
            margin: "1vh 1vh 1vh 0",
            height: "98vh",
          },
        }}
      >
        <Typography
          variant="body1"
          style={{ marginBottom: "15px", fontWeight: 500, marginTop: "-5px" }}
          className={classes.cardIconTitle}
        >
          {t("execution.edit_deliverable")}
        </Typography>
        <Tooltip 
          title={t("execution.cancel")}
          disablePortal={false}
          style={{ zIndex: 10001 }}
        >
          <CloseIcon
            className={classes.iconButtonCustom}
            style={{
              cursor: "pointer",
              fontSize: "22px",
              position: "absolute",
              right: 40,
              top: 10,
            }}
            onClick={() => setOpenEditDialog(false)}
          />
        </Tooltip>
        <Tooltip 
          title={t("execution.save")}
          disablePortal={false}
          style={{ zIndex: 10001 }}
        >
          <SaveButton loading={isSaving} onClick={handleDrawerSave} />
        </Tooltip>
        {editingDeliverable && (
          <GridContainer spacing={1}>
            <GridItem
              xs={12}
              md={12}
              sm={12}
              style={{ marginBottom: "10px", width: "100%" }}
            >
              <TextField
                label={t("execution.deliverable_name")}
                value={editingDeliverable.deliverable_name}
                onChange={(e) =>
                  setEditingDeliverable({
                    ...editingDeliverable,
                    deliverable_name: e.target.value,
                  })
                }
                classes={{ root: classes.textFieldRoot }}
                InputProps={{
                  classes: { input: classes.inputText },
                  style: { fontSize: "15px" },
                }}
                InputLabelProps={{
                  classes: { root: classes.labelText },
                  shrink: true,
                }}
                style={{ width: "100%" }}
              />
            </GridItem>
            <GridItem xs={12} md={12} style={{ marginBottom: "10px" }}>
              <FormControl
                fullWidth
                className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
              >
                <InputLabel shrink style={{ color: "#666" }}>
                  {t("execution.category")}
                </InputLabel>
                <Select
                  label={t("execution.category")}
                  value={editingDeliverable.category}
                  onChange={(e) =>
                    setEditingDeliverable({
                      ...editingDeliverable,
                      category: e.target.value,
                    })
                  }
                  displayEmpty
                  classes={{
                    select: `${classes.select} ${classes.selectFormControlOverride}`,
                  }}
                  size="small"
                >
                  <MenuItem
                    value="task"
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected,
                    }}
                  >
                    {t("execution.category_task")}
                  </MenuItem>
                  <MenuItem
                    value="risk"
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected,
                    }}
                  >
                    {t("execution.category_risk")}
                  </MenuItem>
                </Select>
              </FormControl>
            </GridItem>

            <GridItem xs={12} md={12} style={{ marginBottom: "10px" }}>
              <FormControl
                fullWidth
                className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
              >
                <InputLabel shrink style={{ color: "#666" }}>
                  {t("execution.owner")}
                </InputLabel>
                <Select
                  value={editingDeliverable.responsible_id || ""}
                  onChange={(e) =>
                    setEditingDeliverable({
                      ...editingDeliverable,
                      responsible_id: e.target.value,
                      owner:
                        owners.find((o) => o.id === e.target.value)?.name || "",
                    })
                  }
                  size="small"
                  classes={{
                    select: `${classes.select} ${classes.selectFormControlOverride}`,
                  }}
                >
                  {owners.map((u) => (
                    <MenuItem
                      key={u.id}
                      value={u.id}
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                    >
                      {u.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} md={12} style={{ marginBottom: "10px" }}>
              <FormControl
                fullWidth
                className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
              >
                <InputLabel
                  shrink
                  InputLabelProps={{
                    classes: { root: classes.labelText },
                    shrink: true,
                  }}
                  style={{ color: "#666" }}
                >
                  {t("execution.stage")}{" "}
                </InputLabel>
                <Select
                  label={t("execution.stage")}
                  value={editingDeliverable.stage}
                  onChange={(e) =>
                    setEditingDeliverable({
                      ...editingDeliverable,
                      stage: e.target.value,
                    })
                  }
                  displayEmpty
                  classes={{
                    select: `${classes.select} ${classes.selectFormControlOverride}`,
                  }}
                  size="small"
                >
                  {stages.map((st) => (
                    <MenuItem
                      key={st}
                      value={st}
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                    >
                      {translateStage(st)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} md={4} style={{ marginBottom: "10px" }}>
              <TextField
                type="date"
                label={t("execution.start")}
                value={editingDeliverable.planned_start_date}
                onChange={(e) =>
                  setEditingDeliverable({
                    ...editingDeliverable,
                    planned_start_date: e.target.value,
                  })
                }
                classes={{ root: classes.textFieldRoot }}
                InputProps={{
                  classes: { input: classes.inputText },
                  style: { fontSize: "15px" },
                }}
                InputLabelProps={{
                  classes: { root: classes.labelText },
                  shrink: true,
                }}
                style={{ width: "100%" }}
              />
            </GridItem>
            <GridItem xs={12} md={4} style={{ marginBottom: "10px" }}>
              <TextField
                type="date"
                label={t("execution.end")}
                value={editingDeliverable.planned_end_date}
                onChange={(e) =>
                  setEditingDeliverable({
                    ...editingDeliverable,
                    planned_end_date: e.target.value,
                  })
                }
                classes={{ root: classes.textFieldRoot }}
                InputProps={{
                  classes: { input: classes.inputText },
                  style: { fontSize: "15px" },
                }}
                InputLabelProps={{
                  classes: { root: classes.labelText },
                  shrink: true,
                }}
                style={{ width: "100%" }}
              />
            </GridItem>

            <GridItem xs={12} md={4} style={{ marginBottom: "10px" }}>
              <TextField
                label={t("execution.percent")}
                type="number"
                size="small"
                value={editingDeliverable.percent_real}
                onChange={(e) =>
                  setEditingDeliverable({
                    ...editingDeliverable,
                    percent_real: e.target.value,
                  })
                }
                classes={{ root: classes.textFieldRoot }}
                InputProps={{
                  inputProps: {
                    min: 0,
                    max: 100,
                    step: 1,
                    pattern: "[0-9]*", // Permite apenas números inteiros
                    style: {
                      textAlign: "center",
                      fontSize: "17.2px",
                    },
                  },
                  classes: { input: classes.inputText },
                }}
                InputLabelProps={{
                  classes: { root: classes.labelText },
                  shrink: true,
                }}
                style={{ width: "100%" }}
              />
            </GridItem>

            <GridItem xs={12} md={12} style={{ marginBottom: "10px" }}>
              <TextEditor
                //value={editingDeliverable.description || ""}
                initialContent={editingDeliverable.description || ""}
                setContent={(val) =>
                  setEditingDeliverable((ed) => ({ ...ed, description: val }))
                }
                onChange={(val) =>
                  setEditingDeliverable({
                    ...editingDeliverable,
                    description: val,
                  })
                }
                readOnly={false}
                editorStyle={{
                  backgroundColor: "#fff",
                  maxHeight: "180px",
                  minHeight: "180px",
                  overflowY: "auto",
                  padding: "10px",
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                }}
              />
            </GridItem>
          </GridContainer>
        )}
      </Drawer>

      {/* AI Insights Floating Button - Always visible when viewing Deliverables */}
      {selectedInitiative?.id && (
        <div
          style={{
            position: 'fixed',
            right: 16,
            bottom: 80, // Positioned below the OnePage button
            zIndex: 1300,
          }}
        >
          <Tooltip 
            title={t("deliverable_insights.button_tooltip")} 
            placement="left"
            disablePortal={false}
            style={{ zIndex: 10001 }}
          >
            <IconButton
              style={{
                background: userDetails.implementation_color || '#1976d2',
                color: '#fff',
                border: '1px solid #ccc',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                width: 40,
                height: 40,
              }}
              onClick={handleOpenDeliverableInsights}
            >
              <EmojiObjects style={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </div>
      )}

      {/* Modal de insights de deliverables */}
      <AIInsightsModal
        open={isDeliverableInsightsModalOpen}
        onClose={handleCloseDeliverableInsights}
        title="deliverable_insights.modal_title"
        disclaimer="deliverable_insights.ai_disclaimer"
        content={deliverableInsightsContent}
        isLoading={isLoadingDeliverableInsights}
        onCopy={handleCopyDeliverableToClipboard}
        isCopying={isCopyingDeliverable}
        userDetails={userDetails}
        copyTooltipKey="deliverable_insights.copy_to_clipboard"
        noContentKey="deliverable_insights.no_content"
        closeLabelKey="Fechar"
        loadingComponent={
          <DeliverableInsightsLoading
            isLoading={isLoadingDeliverableInsights}
            interval={3000}
            loadingComponent={
              <ThreeDots
                color={userDetails.implementation_color || '#1976d2'}
                height={80}
                width={80}
                ariaLabel="loading"
              />
            }
          />
        }
        markdownComponents={{
          h1: ({ children }) => (
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '12px', marginTop: '16px' }}>
              {children}
            </Typography>
          ),
          h2: ({ children }) => (
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '10px', marginTop: '14px' }}>
              {children}
            </Typography>
          ),
          h3: ({ children }) => (
            <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: '12px' }}>
              {children}
            </Typography>
          ),
          h4: ({ children }) => (
            <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '6px', marginTop: '10px' }}>
              {children}
            </Typography>
          ),
          p: ({ children }) => (
            <Typography variant="body1" style={{ marginBottom: '8px' }}>
              {children}
            </Typography>
          ),
          strong: ({ children }) => (
            <span style={{ fontWeight: 'bold' }}>{children}</span>
          ),
          li: ({ children }) => (
            <li style={{ marginBottom: '4px' }}>{children}</li>
          ),
          ul: ({ children }) => (
            <ul style={{ marginBottom: '12px', paddingLeft: '20px' }}>{children}</ul>
          ),
          ol: ({ children }) => (
            <ol style={{ marginBottom: '12px', paddingLeft: '20px' }}>{children}</ol>
          ),
        }}
      />

      {/*Cancellation dialog of editing mode */}
      <Dialog
        open={isCancelDialogOpen}
        onClose={handleCloseCancelDialog}
        aria-labelledby="cancel-dialog-title"
        PaperProps={{
          style: {
            borderRadius: 8,
            padding: "24px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <DialogTitle
          id="cancel-dialog-title"
          style={{
            fontSize: 20,
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "20px",
            marginTop: "-20px",
          }}
        >
          {t("initiative_selected.cancel_confirmation_title")}
        </DialogTitle>
        <DialogContent
          style={{
            textAlign: "center",
            marginBottom: "40px",
            padding: 0,
          }}
        >
          <Typography variant="body1" style={{ lineHeight: 1.6 }}>
            {t("initiative_selected.cancel_confirmation_text")}
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: "right", padding: 0 }}>
          <Button
            onClick={handleCloseCancelDialog}
            style={{
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: "8px 15px",
              fontWeight: "bold",
              textTransform: "none",
              marginRight: "12px",
            }}
          >
            {t("initiative_selected.cancel_no")}
          </Button>
          <Button
            onClick={handleConfirmCancel}
            style={{
              backgroundColor: "#d32f2f",
              color: "#fff",
              borderRadius: 8,
              padding: "8px 15px",
              fontWeight: "bold",
              textTransform: "none",
            }}
          >
            {t("initiative_selected.cancel_yes")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

InitiativesExecution.propTypes = {
  selectedInitiative: PropTypes.shape({
    id: PropTypes.number.isRequired,
    initiative: PropTypes.string,
  }).isRequired,
  deliverablesData: PropTypes.shape({
    deliverables: PropTypes.arrayOf(
      PropTypes.shape({
        initiative_id: PropTypes.number.isRequired,
        deliverable_id: PropTypes.number.isRequired,
        deliverable_name: PropTypes.string.isRequired,
        owner: PropTypes.string,
        status: PropTypes.string,
        stage: PropTypes.string,
        planned_start_date: PropTypes.string,
        planned_end_date: PropTypes.string,
        description: PropTypes.string,
        percent_real: PropTypes.number.isRequired,
        percent_planned: PropTypes.number.isRequired,
      })
    ),
    deliverables_summary: PropTypes.shape({
      percent_real: PropTypes.number.isRequired,
      percent_planned: PropTypes.number.isRequired,
      percent_diff: PropTypes.number.isRequired,
    }),
  }),
  classes: PropTypes.object.isRequired,
  clientColor: PropTypes.string.isRequired,
};

InitiativesExecution.defaultProps = {
  deliverablesData: null,
};

export default InitiativesExecution;
